<template>
    <UiBadge :type="badgeType">
        {{ statusLabel }}
    </UiBadge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { lang } from '@/lang/composable';
import type { BadgeType } from '@src/Common/Components/UI/Badge.vue';

interface Props {
    status: string;
}

const props = defineProps<Props>();

const langPrefix = 'congresses::ticket-orders';

const badgeType = computed<BadgeType>(() => {
    switch (props.status) {
        case 'draft':
            return 'muted';
        case 'pending_payment':
            return 'warning';
        case 'paid':
            return 'success';
        case 'cancelled':
            return 'danger';
        default:
            return 'muted';
    }
});

const statusLabel = computed(() => lang(`${langPrefix}.status.${props.status}`) || props.status);
</script>
